import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";

export const CustomRedirectToggle = () => (
  <Form.Item
    name="redirect_url_enabled"
    translationRoot="settings.paywalls.modal.tabs.post_purchase"
    className="!mt-0 !py-0"
    inline
    hideBorder
    hideDescription
    labelClassName="text-xl tightest font-semibold"
    tooltipText={t(
      "settings.paywalls.modal.tabs.post_purchase.redirect_url_tooltip",
    )}
  >
    <Form.ToggleSwitch variant="large" name="redirect_url_enabled" />
  </Form.Item>
);
